import { Col } from "reactstrap";
import CommonTourSocialMedia from "../Common/CommonTourSocialMedia";

export const FourthStyleSocialMedia = () => {
  return (
    <Col sm="4" className="align-self-center mt-0 text-end">
      <CommonTourSocialMedia time="9 Month ago" className="step8" />
    </Col>
  );
};
